import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-icon',
  templateUrl: './edit-icon.component.html',
  styleUrl: './edit-icon.component.scss'
})
export class EditIconComponent {

}
